const { min, max } = Math;

class DistanceMap {
    constructor() {
        this.width = null;
        this.height = null;
        this.data = null;
        this.maxDistance = new Map();
    }

    calculate(mask) {
        const { width, height } = mask;

        if (width !== this.width || height !== this.height) {
            this.width = width;
            this.height = height;
            this.data = new Uint32Array(width*height);
        }

        const getAtPos = mask.makeGetterAtPos();

        const data = this.data;
        const maxDistance = this.maxDistance;

        maxDistance.clear();

        {
            let topRowPos = 0, bottomRowPos = (height-1)*width;
            for (let x = 0; x < width; x++) {
                maxDistance.set(getAtPos(topRowPos), 0);
                maxDistance.set(getAtPos(bottomRowPos), 0);

                data[topRowPos++] = 0;
                data[bottomRowPos++] = 0;
            }

            let leftRowPos = width, rightRowPos = width+width-1;
            const yCount = height-2;
            for (let y = 0; y < yCount; y++) {
                maxDistance.set(getAtPos(leftRowPos), 0);
                maxDistance.set(getAtPos(rightRowPos), 0);

                data[leftRowPos] = 0;
                data[rightRowPos] = 0;
                leftRowPos += width;
                rightRowPos += width;
            }
        }

        for (let y = 1; y < height-1; y++) {
            let pos = y*width+1;

            let id = getAtPos(pos-1);
            let distance = 0;

            for (let x = 1; x < width-1; x++) {
                let posNx = pos-1, posNy = pos-width;

                let idNx = id;
                id = getAtPos(pos);

                let distNx = distance;

                if (id !== idNx || id !== getAtPos(posNy)) {
                    distance = 0;
                } else {
                    distance = min(distNx, data[posNy])+1;
                }

                data[pos] = distance;

                pos++;
            }
        }

        for (let y = height-2; y > 0; y--) {
            let pos = y*width+width-2;

            let id = getAtPos(pos+1);
            let distance = 0;

            for (let x = width-2; x > 0; x--) {
                let posNx = pos+1, posNy = pos+width;

                let idNx = id;
                id = getAtPos(pos);

                let distNx = distance;

                if (id !== idNx || id !== getAtPos(posNy)) {
                    distance = 0;
                } else {
                    distance = min(data[pos], distNx+1, data[posNy]+1);
                }

                let maxDist = max(maxDistance.get(id) || 0, distance);
                maxDistance.set(id, maxDist);

                data[pos] = distance;

                pos--;
            }
        }
    }

    //debug
    generateImageData() {
        const { width, height, data } = this;

        let maxDist = 1;
        const dataSize = width*height;
        for (let pos = 0; pos < dataSize; pos++) {
            maxDist = Math.max(maxDist, data[pos]);
        }

        const array = new Uint8ClampedArray(dataSize*4);
        const mult = 255/maxDist*4;
        let offset = 0;
        for (let pos = 0; pos < dataSize; pos++) {
            let v = Math.round(data[pos]*mult);
            array[offset++] = v;
            array[offset++] = v;
            array[offset++] = v;
            array[offset++] = 255;
        }

        return new ImageData(array, width, height);
    }
}

export default DistanceMap;
